export const costs = [
  'Sleepless nights searching for ways to translate complex drilling and well engineering concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how drilling and well engineering connects to their futures, careers, or real-world well operations.",
  "Awkward silences when a student asks about well control or drilling performance and you don't have a clear answer.",
  'Weekends lost building lesson plans, drilling projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach well planning, drilling systems, well construction, pressure management, or troubleshooting without adequate resources.',
];
